import { FormInstance } from "antd";

export function setFormFields<T extends object>(
  form: FormInstance,
  initialValues: T,
) {
  form.setFields(
    Object.entries(initialValues).map(([name, value]) => ({
      name,
      value,
      touched: false,
    })),
  );
}
